export const convertMarkdownTablesToHtml = (text) => {
  if (!text || typeof text !== "string") return text;

  const lines = text.split("\n");
  const output = [];
  let i = 0;

  const isTableHeader = (line) => /\|/.test(line.trim());
  const isSeparator = (line) => /^\s*\|?\s*:?[-\s|:]+:?\s*\|?\s*$/.test(line);

  const parseRow = (line, tag) => {
    const cells = line
      .trim()
      .replace(/^\|/, "")
      .replace(/\|$/, "")
      .split("|")
      .map((c) => c.trim());
    return (
      `<tr>` + cells.map((c) => `<${tag}>${c}</${tag}>`).join("") + `</tr>`
    );
  };

  while (i < lines.length) {
    const line = lines[i];
    const next = lines[i + 1] || "";

    if (isTableHeader(line) && isSeparator(next)) {
      const header = line;
      i += 2; // skip header + separator
      const bodyRows = [];
      while (
        i < lines.length &&
        /\|/.test(lines[i].trim()) &&
        !/^\s*$/.test(lines[i])
      ) {
        bodyRows.push(lines[i]);
        i += 1;
      }

      const thead = `<thead>${parseRow(header, "th")}</thead>`;
      const tbody = bodyRows.length
        ? `<tbody>${bodyRows.map((r) => parseRow(r, "td")).join("")}</tbody>`
        : "";
      output.push(`<table>${thead}${tbody}</table>`);
      continue;
    }

    output.push(line);
    i += 1;
  }

  return output.join("\n");
};
